module.exports = __webpack_public_path__ + "img/Banner04.aa8abd21.png";